import { useCallback } from 'react'
import { useGoogleLogin } from '@react-oauth/google'
import { useDispatch, useSelector } from 'react-redux'
import { login } from '@action/auth'
import * as Yup from 'yup'
import {
  AuthCard,
  AuthContainer,
  AuthFooter,
  AuthSpacer,
  AuthSubTitle,
  AuthTitle,
  LoginWithGoogle,
} from '@/styles/layouts/auth'
import Form, { FormGroup, FormInput, FormLabel } from '@util/form'
import { Button } from '@style/components/button'
import { getRegisterStatusSelector } from '@/services/selectors/auth/login'
import { REQUEST } from '@constant/reducer-status'
import { applyMiddleware } from '@middleware/index'
import Link from 'next/link'
import { useRouter } from 'next/router'
import Image from 'next/image'
import { signup } from '@action/auth'

const validationSchema = Yup.object().shape({
  email: Yup.string().email().required(),
  password: Yup.string().required(),
  confirm_password: Yup.string().oneOf([Yup.ref('password'), null], 'Passwords must match'),
})

const initialValues = {
  email: '',
  password: '',
  confirm_password: '',
}

const SignUp = () => {
  const Dispatch = useDispatch()
  const [status, errors] = useSelector(getRegisterStatusSelector)
  const router = useRouter()
  const { price } = router.query

  const handleFormSubmit = (form) => {
    Dispatch(signup({ ...form, priceLookupKey: price ? [price] : ['default_price'] }))
  }

  const handleLogin = useGoogleLogin({
    onSuccess: ({ code }) => {
      Dispatch(login({ code }))
    },
    flow: 'auth-code',
    scope: 'profile email https://www.googleapis.com/auth/webmasters',
  })

  const handleGoogleResponse = useCallback(({ code }) => {
    Dispatch(login({ code }))
  }, [])

  return (
    <AuthContainer>
      <AuthCard>
        <div style={{ display: 'flex', justifyContent: 'center', width: '100%', marginBottom: 16 }}>
          <Image height={90} width={90} src='/assets/images/logo-mini.svg' />
        </div>
        <AuthTitle>Create Seotisfy Account</AuthTitle>
        <AuthSubTitle>Enjoy 14 days free trial !</AuthSubTitle>
        <LoginWithGoogle onClick={handleLogin}>
          <Image src='/assets/icons/google.svg' height={16} width={15} />
          <span>SignUp with Google</span>
        </LoginWithGoogle>
        <AuthSpacer>
          <span className='text-[15px] text-center'>Or sign up with email</span>
        </AuthSpacer>
        <Form initialValues={initialValues} validation={validationSchema} onSubmit={handleFormSubmit}>
          {form => (
            <>
              <FormGroup>
                <FormLabel htmlFor='email'>Email Address</FormLabel>
                <FormInput
                  id='email'
                  name='email'
                  placeholder='email@example.com'
                  form={form}
                  withError
                  errors={errors}
                />
              </FormGroup>
              <FormGroup>
                <FormLabel htmlFor='email'>Password</FormLabel>
                <FormInput
                  id='password'
                  type='password'
                  name='password'
                  placeholder=''
                  form={form}
                  withError
                  errors={errors}
                />
              </FormGroup>
              <FormGroup>
                <FormLabel htmlFor='email'>Confirm password</FormLabel>
                <FormInput
                  id='confirm_password'
                  type='password'
                  name='confirm_password'
                  placeholder=''
                  form={form}
                  withError
                  errors={errors}
                />
              </FormGroup>
              <Button
                type='submit'
                btnFontSize='md'
                btnFontWeight='bold'
                btnSize='block'
                btnColor='white'
                btnBlock
                disabled={status == REQUEST}
                btnBackground='primary'
                style={{ marginTop: '2rem' }}
              >
                {status == REQUEST ? 'Loading...' : 'Create account'}
              </Button>
            </>
          )}
        </Form>
        <AuthFooter>
          <span>
            Already have an account ?&nbsp;
            <Link href='/auth/login'>Login</Link>
          </span>
        </AuthFooter>
      </AuthCard>
    </AuthContainer>
  )
}

export default applyMiddleware(SignUp, async ({ useMiddleware }) => {
  await useMiddleware('guest')
})
